import { PANEL_SETTINGS_TAB, PANEL_COOKIES_TAB, PANEL_POLICY_TAB, PANEL_DATA_TAB } from "types/config-files/mainConfig";

const SHORTCODE_REGEX = /\[cf_(\w+)\](.*?)\[\/cf_\1\]/g;

export interface ShortcodeAction {
  acceptAll: () => void;
  acceptDefault: () => void;
  acceptSelected: () => void;
  deny: () => void;
  toggleSettingsPanel: (open: boolean) => void;
  changePanelTab: (tab: string) => void;
}

export const processShortcodes = (
  text: string,
  buttonClass: string = "shortcode-button"
): string => {
  if (!text) return text;

  const cleanedText = text
    .replace(/<p>\s*<p>/g, '<p>')
    .replace(/<\/p>\s*<\/p>/g, '</p>');

  return cleanedText.replace(SHORTCODE_REGEX, (match, actionName, displayText) => {
    return `<button class="${buttonClass}" data-action="${actionName}">${displayText}</button>`;
  });
};

export const handleShortcodeClick = (
    event: MouseEvent,
    actions: ShortcodeAction,
    isSettingsPanelOpen: boolean
): void => {
  const target = event.target as HTMLElement;
  
  // Find the button element (traverse up the DOM tree)
  let buttonElement = target;
  if (buttonElement.tagName !== 'BUTTON') {
    buttonElement = buttonElement.closest("button") as HTMLElement;
  }

  const disableSettingsPanel = () => {
    if (isSettingsPanelOpen) {
      actions.toggleSettingsPanel(false);
    }
  }
  
  if (buttonElement && buttonElement.hasAttribute('data-action')) {
    const action = buttonElement.getAttribute('data-action');

    switch (action) {
      case "acceptAll": actions.acceptAll(); disableSettingsPanel(); break;
      case "acceptDefault": actions.acceptDefault(); disableSettingsPanel(); break;
      case "acceptSelected": actions.acceptSelected(); disableSettingsPanel(); break;
      case "deny":
      case "reject": actions.deny(); disableSettingsPanel(); break;
      case "openSettings":
      case "customize": actions.toggleSettingsPanel(true); break;
      case "tab_settings": 
        actions.toggleSettingsPanel(true);
        actions.changePanelTab(PANEL_SETTINGS_TAB);
        break;
      case "tab_cookies":
        actions.toggleSettingsPanel(true);
        actions.changePanelTab(PANEL_COOKIES_TAB);
        break;
      case "tab_policy":
        actions.toggleSettingsPanel(true);
        actions.changePanelTab(PANEL_POLICY_TAB);
        break;
      case "tab_data":
        actions.toggleSettingsPanel(true);
        actions.changePanelTab(PANEL_DATA_TAB);
        break;
    }
  }
};

export const hasShortcodes = (text: string): boolean => {
  if (!text) return false;
  SHORTCODE_REGEX.lastIndex = 0;
  return SHORTCODE_REGEX.test(text);
};
